import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export interface CustomTooltipProps extends TooltipProps {
  testId?: string;
  isMobile?: boolean;
}

const CustomTooltip = styled(
  ({ className, testId, ...props }: CustomTooltipProps) => (
    <Tooltip
      {...props}
      PopperProps={{ disablePortal: true }}
      data-testId={testId}
      arrow
      classes={{ popper: className }}
    />
  ),
)(({ theme, isMobile }) => ({
  zIndex: isMobile ? 1100 : 9,
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.darkTeal.main,
    width: 20,
    height: 20,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.darkTeal.main,
    borderRadius: "12px",
    padding: "16px",
    maxWidth: isMobile ? "none" : "278px",
    width: "calc(100vw - 32px)",
    margin: isMobile ? "0 16px" : "0 -32px",
  },
  [`&[data-popper-placement*="bottom"]`]: {
    [`& .${tooltipClasses.arrow}`]: {
      "&::before": {
        transformOrigin: "25% 50%",
        borderRadius: 2,
      },
    },
  },
}));

export default CustomTooltip;
